module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "foot_wrap clear"
  }, [_c('div', {
    staticClass: "friend clear"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "title"
  }, [(_vm.language) ? _c('span', [_vm._v("SOLUTIONS")]) : _c('span', [_vm._v("EHR解决方案")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.plan), function(item, index) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/solutionDetail/' + item.PlanId
        }
      }
    }, [_vm._v(_vm._s(item.PlanTitle))])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "title"
  }, [(_vm.language) ? _c('span', [_vm._v("PRODUCTS")]) : _c('span', [_vm._v("产品与服务")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.product), function(item) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/productDetail/' + item.ProductId
        }
      }
    }, [_vm._v(_vm._s(item.ProductTitle))])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "title"
  }, [(_vm.language) ? _c('span', [_vm._v("CASE")]) : _c('span', [_vm._v("客户案例")])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.caselist), function(item, index) {
    return (index < 6) ? _c('li', {
      staticClass: "list-item"
    }, [_c('router-link', {
      attrs: {
        "to": "/case"
      }
    }, [_vm._v(_vm._s(item.CaseTypeTitle))])], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.language),
      expression: "language"
    }],
    staticClass: "list-item",
    on: {
      "click": _vm.toShare
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Case Share")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.language),
      expression: "!language"
    }],
    staticClass: "list-item",
    on: {
      "click": _vm.toShare
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("案例分享")])]), _vm._v(" "), (_vm.language) ? _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/case"
    }
  }, [_vm._v("More")])], 1) : _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/case"
    }
  }, [_vm._v("更多")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "title"
  }, [(_vm.language) ? _c('span', [_vm._v("ABOUT US")]) : _c('span', [_vm._v("关于我们")])]), _vm._v(" "), (_vm.language) ? _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/two"
    }
  }, [_vm._v("Company Profile")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/three"
    }
  }, [_vm._v("Vanguard Memorabilia")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/four"
    }
  }, [_vm._v("Team Introduction")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/six"
    }
  }, [_vm._v("CONTACT US")])], 1), _vm._v(" "), _vm._m(0)]) : _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/two"
    }
  }, [_vm._v("公司介绍")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/three"
    }
  }, [_vm._v("万古大事记")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/four"
    }
  }, [_vm._v("团队介绍")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/six"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "code_item clear"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.weixinImg
    }
  })]), _vm._v(" "), (_vm.language) ? _c('p', [_vm._v("WeChat QR Code")]) : _c('p', [_vm._v("官方微信二维码")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.appImg
    }
  })]), _vm._v(" "), (_vm.language) ? _c('p', [_vm._v("预约演示系统")]) : _c('p', [_vm._v("预约演示系统")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', [_vm._v(_vm._s(_vm.CopyRight))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.BackUp))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "http://vbs.vgtech.com.cn/channel/",
      "target": "_blank"
    }
  }, [_vm._v("Channels To Recruit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "http://vbs.vgtech.com.cn/channel/",
      "target": "_blank"
    }
  }, [_vm._v("渠道招募")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/logo_01.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-243841ab"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/foot/foot.vue
// module id = 64
// module chunks = 15